import React, { useState } from "react";

import snakeToPascal from "../../../tools";
import dayjs from "dayjs";
import { useEditorStore } from "../../../shared/stores/useEditorStore";
import FieldDependenciesPanel from "./reusables/FieldDependenciesPanel";


export default function OutputGridField({ name, field, compareWithField, scrollRef, onScroll, scenarioId = null, onNavigate = undefined }) {
    const storeScenarioId = useEditorStore(s => s.scenarioId);

    // Build a comparison structure from compareWithField for quick lookup
    const compareGrid = React.useMemo(() => {
        if (!compareWithField?.value?.value) return null;
        return compareWithField.value.value;
    }, [compareWithField]);

    const isDifferent = (rowIndex: number, key: string, currentValue: any) => {
        if (!compareGrid || !compareGrid[rowIndex] || !compareGrid[rowIndex][key]) return false;
        const compareValue = compareGrid[rowIndex][key].value;

        // For numbers, use tolerance comparison
        if (typeof currentValue === 'number' && typeof compareValue === 'number') {
            return Math.abs(currentValue - compareValue) > 0.01;
        }

        // For other types, use strict equality
        return currentValue !== compareValue;
    };

    const [showDeps, setShowDeps] = useState(false);

    return (
        <div className="ml-3">
            <div className="flex items-center mb-1">
                <button
                    onClick={() => setShowDeps(true)}
                    className="p-1 rounded hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors ml-auto"
                    title="View dependencies"
                >
                    <span className="material-symbols-outlined text-[18px]">device_hub</span>
                </button>
            </div>
            <FieldDependenciesPanel
                isOpen={showDeps}
                onClose={() => setShowDeps(false)}
                scenarioId={scenarioId || storeScenarioId}
                fieldId={field.id}
                fieldName={name}
                onNavigate={onNavigate}
            />
            <div className="mt-2 mr-2">
                <div className="border border-slate-200 rounded-lg overflow-auto" ref={scrollRef} onScroll={onScroll}>
                    <table className="min-w-[650px] w-full border-collapse">
                        <thead className="bg-slate-50">
                            <tr className="border-b border-slate-200">
                                {Object.keys(field.elems).map(key => (
                                    <th key={key} className="w-[200px] p-2 text-left font-bold">{snakeToPascal(key)}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                        {
                            field.value.value.map((e, rowIndex) => (
                                <tr key={rowIndex} className="border-b border-slate-200 hover:bg-slate-50">
                                    {Object.keys(field.elems).map(key => {
                                        const cellValue = e[key].value;
                                        const hasDifference = isDifferent(rowIndex, key, cellValue);
                                        const cellClass = hasDifference
                                            ? "w-[200px] p-2 bg-yellow-100 font-bold"
                                            : "w-[200px] p-2";
                                        return (
                                            <td key={key} className={cellClass}>{cellValue}</td>
                                        );
                                    })}
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            {/* OutputFieldFooter not yet implemented */}
        </div>
    )
}
